import React from "react";
import {Dialog, TextInputField, toaster} from "evergreen-ui";
import External from "../external/external";


class GetInTouchDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            venueMobile: ""
        };
    };

    inputChange = async (e) => {
        this.setState({
            venueMobile: e.target.value
        })
    };

    getInTouch = async () => {
        const {
            venueMobile
        } = this.state;
        const {
            showDialog,
            getInTouchData,
            showUnavailabilityDialog,
        } = this.props;

        showDialog(false);
        const getInTouch = await External.getInTouch({venueMobile, bookingId: getInTouchData["bookingId"]});
        if (getInTouch.data["requestStatus"]) {
            await showUnavailabilityDialog(true, getInTouchData["slot"]);
            toaster.success("You will receive a call shortly", {
                id: "get-in-touch"
            })
        } else {
            toaster.warning(getInTouch.data["message"], {
                id: "get-in-touch"
            })
        }
    };

    render() {

        const {
            isShown,
            showDialog
        } = this.props;

        return (
            <Dialog
                isShown={isShown}
                onCloseComplete={() => showDialog(false)}
                title={"Get in Touch"}
                onConfirm={this.getInTouch}
            >
                <TextInputField
                    label={"Enter your phone number"}
                    onChange={(e) => this.inputChange(e)}
                />
            </Dialog>
        )
    }
}

export default GetInTouchDialog;
